module.exports = __webpack_public_path__ + "img/bowen4.4efcf83e.png";